import { Locale } from '@ps-smart-cp/ppfw-client';

const secondhandAssetClassNameConfig = {
  normalAsset: new Map([[Locale.ja, '通常資産']]),
  secondhandAsset: new Map([[Locale.ja, '中古資産']]),
} satisfies Record<string, Map<Locale, string>>;

export { secondhandAssetClassNameConfig };
